<template>
	<div class="QuestionOutline">
		<!-- <div class="icon-box">
			<el-tooltip class="item" effect="light" content="复制" placement="top">
				<i class="zxwj-iconfont zxwj-icon-fuzhi" @click="copyClick"></i>
			</el-tooltip>
			<el-tooltip class="item" effect="light" content="粘贴" placement="top">
				<i class="zxwj-iconfont zxwj-icon-niantie1" @click="pasteClick"></i>
			</el-tooltip>
		</div> -->
		<el-tree ref="tree" :data="data" :props="defaultProps" empty-text="暂无数据" :default-expand-all="true" :highlight-current="true" node-key="qid" @node-click="nodeClick">
			<span class="span-ellipsis" slot-scope="{ node, data }">
				{{ data.quesIndex || '' }}
				<span :title="node.label" v-html="node.label"></span>
			</span>
		</el-tree>
	</div>
</template>

<script>
export default {
	name: 'QuestionOutline',
	components: {},
	props: {
		list: {
			type: Array,
			default: () => {
				return [];
			}
		},
		type: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label',
				qid: 'qid'
			},
			activeQuesIndex: 0
		};
	},
	computed: {},
	watch: {
		list(newV) {
			this.data = [];
			if (this.type == 'ks') {
				this.getData([402, 404]);
			} else {
				this.getData(['26']);
			}
		},
		activeQuesIndex(val) {
			this.$nextTick(() => {
				//默认选中
				this.$refs['tree'].setCurrentKey(data[val].qid);
			});
		}
	},
	created() {},
	methods: {
		copyClick() {
			this.$emit('copyClick');
		},
		pasteClick() {
			this.$emit('pasteClick');
		},
		getData(typeArr) {
			if (this.type == 'ks' || (this.type == 'wj' && this.list.length > 0 && this.list[0].questionsTypeId != '26')) {
				this.data = [
					{
						children: [],
						label: '第一页'
					}
				];
			}
			this.list.forEach((info, index) => {
				if (typeArr.indexOf(info.questionsTypeId) == -1) {
					let obj = {
						label: this.$functions.htmlFormat(info.questionsName),
						quesIndex: info.quesIndex != null  ? info.quesIndex + 1 : info.quesIndex,
						qid: info.qid
					};
					if (this.data.length > 0) {
						this.data[this.data.length - 1].children.push(obj);
					}
				} else {
					let obj = {
						label: this.$functions.htmlFormat(info.questionsName),
						qid: info.qid,
						quesIndex: info.quesIndex != null ? info.quesIndex + 1 : info.quesIndex,
						children: []
					};
					this.data.push(obj);
				}
			});
			this.data = this.data.map((info, index) => {
				info.label = `第${index + 1}页`;
				return info;
			});
		},
		nodeClick(e) {
			let index = e.qid ? 0 : -1;
			this.$emit('goAnchor', `name${e.qid}`, e.qid, index);
		}
	}
};
</script>

<style lang="scss" scoped>
/deep/.el-tree-node__content {
	font-size: 14px;
}
.span-ellipsis {
	width: 80%;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.icon-box {
	display: flex;
	justify-content: end;
	align-items: center;
	i {
		display: inline-block;
		font-size: 18px;
		color: #999;
		cursor: pointer;
		margin-left: 10px;
	}
}
</style>
